import { isAppInstalled, isIOSOrIPadOS } from '../services/pushNotification'

/**
 * Where a blocked notification permission is lifted, browser by browser. The
 * page can never ask again once somebody said no in the browser's prompt: all
 * it can do is say where the switch is.
 */
export type UnblockBrowser =
  | 'chrome-desktop'
  | 'chrome-android'
  | 'android-app'
  | 'firefox'
  | 'safari-macos'
  | 'ios-app'
  | 'generic'

export const UNBLOCK_KEY: Record<UnblockBrowser, string> = {
  'chrome-desktop': 'chromeDesktop',
  'chrome-android': 'chromeAndroid',
  'android-app': 'androidApp',
  firefox: 'firefox',
  'safari-macos': 'safariMacos',
  'ios-app': 'iosApp',
  generic: 'generic',
}

export function detectUnblockBrowser(): UnblockBrowser {
  const ua = navigator.userAgent
  const installed = isAppInstalled()

  if (isIOSOrIPadOS()) return installed ? 'ios-app' : 'generic'
  if (/Android/.test(ua)) {
    if (installed) return 'android-app'
    return /Firefox\//.test(ua) ? 'firefox' : 'chrome-android'
  }
  if (installed) return 'generic'
  if (/Firefox\//.test(ua)) return 'firefox'
  if (/Chrome\/|Chromium\/|Edg\//.test(ua)) return 'chrome-desktop'
  if (/Macintosh/.test(ua) && /Safari\//.test(ua)) return 'safari-macos'
  return 'generic'
}
